import React from "react";
// everything is done using tailwindcss except the background image and overlay animation which is done using css
import './PhotoTile.css';

/**
 * 
 * @param {*} images This component takes an array of images as props and renders them in a tile format.
 * The images are displayed in a 3-column layout on large screens and a single column layout on small screens.
 * The component uses flex to layout the images in a grid format. 
 * The params that will be passed to the component are:
 * - image: The image URL
 * - title: The title of the image
 * - link: The link to navigate to when the image is clicked (if link is given it will navigate to the link else it will navigate to #)
 * sample array of images:
 * const sampleImages = [
 *    {
 *     image: 'https://images.pexels.com/photos/577769/pexels-photo-577769.jpeg?cs=srgb&dl=pexels-parag-deshmukh-180046-577769.jpg&fm=jpg',
 *     title: 'Headphones',
 *     link: 'https://placehold.co/600x400'
 *    },
 * ]
 * @returns photo tile component
 */
const PhotoTileModule = ({ images }) => {
    const [rows, setRows] = React.useState([]);

    // Split the images into rows of 3, to display in a 3-column layout
    React.useEffect(() => {
        setRows(images.reduce((acc, image, index) => {
            if (index % 3 === 0) acc.push([]);
            acc[acc.length - 1].push(image);
            return acc;
        }, []));
    }, [images]);

    return (
        <div className="image-tile-container flex flex-col gap-4">
            {rows.map((row, rowIndex) => (
                // If the row index is odd, reverse the order of the images to create a zig-zag effect
                <div
                    key={rowIndex}
                    className={`image-tile-wrapper flex ${rowIndex % 2 === 0 ? '' : 'lg:flex-row-reverse'} flex-col lg:flex-row gap-4`}
                >
                    <div className={`image-tile flex justify-center items-center ${row[1] || row[2] ? 'lg:w-[66%]' : ''} w-full`}>
                        <img
                            src={row[0]?.image}
                            alt={row[0]?.title}
                            className="absolute w-full h-full object-cover"
                        />
                        <div className="overlay">
                            {/* <a href={row[0]?.link ? row[0]?.link : '#'}> {row[0]?.title} </a> */}
                            <a href={`/project/${row[0]?.id}`}>{row[0]?.title}</a>
                            <p className="absolute bottom-0 right-0 mb-2 mr-2 bg-black bg-opacity-75 px-3 py-2 rounded-2xl">{row[0]?.category}</p>
                        </div>
                    </div>

                    {(row[1] || row[2]) && (
                        <div className="flex gap-4 flex-col md:flex-row lg:flex-col justify-between lg:w-[33%] w-full">
                            {row[1] && (
                                <div className="image-tile flex justify-center items-center w-full">
                                    <img
                                        src={row[1]?.image}
                                        alt={row[1]?.title}
                                        className="absolute w-full h-full object-cover"
                                    />
                                    <div className="overlay overlay-small">
                                        <a href={`/project/${row[1]?.id}`}>{row[1]?.title}</a>
                                        {/* <a href={row[1]?.link ? row[1]?.link : '#'}> {row[1]?.title} </a> */}
                                        <p className="absolute bottom-0 right-0 mb-2 mr-2 bg-black bg-opacity-75 px-3 py-2 rounded-2xl">{row[1]?.category}</p>
                                    </div>
                                </div>
                            )}
                            {row[2] && (
                                <div className="image-tile flex justify-center items-center w-full">
                                    <img
                                        src={row[2]?.image}
                                        alt={row[2]?.title}
                                        className="absolute w-full h-full object-cover"
                                    />
                                    <div className="overlay overlay-small">
                                        <a href={`/project/${row[2]?.id}`}>{row[2]?.title}</a>
                                        {/* <a href={row[2]?.link ? row[2]?.link : '#'}> {row[2]?.title} </a> */}
                                        <p className="absolute bottom-0 right-0 mb-2 mr-2 bg-black bg-opacity-75 px-3 py-2 rounded-2xl">{row[2]?.category}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PhotoTileModule;
